import { call, put, takeLatest } from "redux-saga/effects";
import {
  NativeAppLogsInit,
  NativeAppLogsSuccess,
  NativeAppLogsFailure,
} from "./NativeAppLogsSlice";
import { _API_ENDPOINT, SUCCESS } from "../../constants/AppConstants";
import NativeAppLogsPayload from "../../utils/NativeApp/LogsPayload";
import { _CALLPOSTAPI } from "../../api/apiHandler";
import i18next from "i18next";

// API Handler
function __APIHANDLER(payload) {
    const endpoint = _API_ENDPOINT.STORE_NATIVE_APP_LOGS;
    return _CALLPOSTAPI(endpoint, payload)
    .then((response) => response)
    .catch((error) => { throw error; });
}

// Worker Saga
function* handleCreateNativeAppLogs(action) {
  try {
    const { isWebToApp, isAppToWeb, webToAppRequestURL, isError, errorPathname } = action.payload;
    const payload = NativeAppLogsPayload({isWebToApp, isAppToWeb, webToAppRequestURL, isError, errorPathname});
    const response = yield call(__APIHANDLER, payload);
    if(response.actionStatus.toUpperCase === SUCCESS){
        yield put(NativeAppLogsSuccess(response));
    } else {
        yield put(NativeAppLogsFailure(i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")));
    }
  } catch (error) {
    yield put(NativeAppLogsFailure(error.message));
  }
}

// Watcher Saga
export default function* watchNativeAppLogs() {
  yield takeLatest(NativeAppLogsInit.type, handleCreateNativeAppLogs);
}
